module.exports = __webpack_public_path__ + "img/Chronopost.478355bf.webp";